/* Bundle review badge override
 *
 * On every page, find any Fera `product_reviews_summary` placeholder whose
 * data-product-id matches a known bundle product (from the pre-baked list in
 * snippets/bundle-product-ids.liquid), and replace it with a brand-level
 * "★★★★★ 20,000+ Reviews" badge. Covers both PDP pages and collection cards
 * where Fera injects the badge after the initial HTML.
 *
 * Per-product Fera reviews are still rendered for non-bundle products.
 */
(function () {
  'use strict';
  if (!window.SCENT_BUNDLE_PRODUCT_IDS || !Array.isArray(window.SCENT_BUNDLE_PRODUCT_IDS)) return;
  var bundleIds = window.SCENT_BUNDLE_PRODUCT_IDS.map(String);
  if (!bundleIds.length) return;
  var bundleSet = Object.create(null);
  bundleIds.forEach(function (id) { bundleSet[id] = true; });

  var BADGE_HTML =
    '<span class="bpp-reviews-badge" style="display:inline-flex;align-items:center;gap:6px;font-size:14px;line-height:1;">' +
      '<span style="color:#ffd84f;letter-spacing:1px;font-size:16px;line-height:1;">★★★★★</span>' +
      '<span style="color:#444;">20,000+ Reviews</span>' +
    '</span>';

  function isBundle(el) {
    var pid = el.getAttribute && el.getAttribute('data-product-id');
    return pid && bundleSet[String(pid)];
  }

  function overrideOne(container) {
    if (container.dataset.bppReviewOverride === '1' && container.querySelector('.bpp-reviews-badge')) return;
    container.dataset.bppReviewOverride = '1';
    container.innerHTML = BADGE_HTML;
  }

  function scan(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll
      ? scope.querySelectorAll('[data-fera-container="product_reviews_summary"]')
      : [];
    for (var i = 0; i < containers.length; i++) {
      if (isBundle(containers[i])) overrideOne(containers[i]);
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }
  ready(function () { scan(); });
  [200, 600, 1500, 3000, 6000].forEach(function (ms) { setTimeout(function () { scan(); }, ms); });

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-fera-container="product_reviews_summary"]')) {
            if (isBundle(node)) overrideOne(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        }
      }
    });
    ready(function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
